module.exports = __webpack_public_path__ + "img/vehicle-slides-with-backdrop-ford.15c5f1cd.png";